import { ChangeDetectionStrategy, Component, DOCUMENT, inject, input, OnInit, signal } from '@angular/core';
import { HeroLayout4 } from '@components/hero/components/hero-layout-4/model';
import { DataLayerService } from '@services/data-layer';
import { ResponsiveService } from '@services/responsive';
import { ButtonComponent } from '@shared/components/button';
import { ImageComponent } from '@shared/components/image';
import { TitleComponent } from '@shared/components/title';
import { Title } from '@shared/components/title/model';

@Component({
  selector: 'app-hero-layout-4',
  templateUrl: './hero-layout-4.component.html',
  styleUrl: './hero-layout-4.component.scss',
  imports: [TitleComponent, ButtonComponent, ImageComponent],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class HeroLayout4Component implements OnInit {
  readonly data = input.required<HeroLayout4>();
  readonly breakpoints = inject(ResponsiveService).breakpoints;
  title = signal<Title>(null!);
  subtitle = signal<Title>(null!);
  readonly #document = inject<Document>(DOCUMENT);
  readonly #dataLayerService = inject(DataLayerService);
  readonly #window = this.#document.defaultView as Window;

  ngOnInit() {
    this.title.set({
      level: 'H1',
      text: this.data().title.replace(':', ':<br>'),
      color: 'WHITE',
      align: {
        mobile: 'LEFT',
        desktop: 'LEFT',
      },
      size: {
        mobile: 'H1',
        desktop: 'H1',
      },
    });
    this.subtitle.set({
      level: 'SPAN',
      type: 'NORMAL',
      font: 'INTER',
      color: 'WHITE',
      text: this.data().subtitle.toUpperCase(),
      align: {
        mobile: 'LEFT',
        desktop: 'LEFT',
      },
      size: {
        mobile: 'SPAN',
        desktop: 'SPAN',
      },
    });
  }

  goToSection(anchor: string): void {
    const element = this.#document.getElementById(anchor);
    if (element) {
      const rect = element.getBoundingClientRect();
      const offset = 72;
      const scrollOptions: ScrollToOptions = {
        left: rect.left + this.#window.scrollX,
        top: rect.top + this.#window.scrollY - offset,
        behavior: 'smooth',
      };
      this.#window.scrollTo(scrollOptions);
    }
  }

  onButtonClick(button_text_value: string): void {
    this.#dataLayerService.logEvent({
      event_code: 'click_cta_webserie',
      button_text_value,
    });
  }
}
